const EMAIL_PATTERN = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const UUID_LIKE_PATTERN = /\b[a-zA-Z0-9_-]{16,}\b/g;

const SENSITIVE_KEY_PATTERN =
  /(email|uid|userId|customerId|stripeCustomerId|token|secret|password|pin|code)$/i;

export const maskEmail = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  const [local, domain] = trimmed.split("@");
  if (!local || !domain) return "<redacted-email>";
  const prefix = local.length <= 2 ? `${local[0] || "*"}` : `${local.slice(0, 2)}`;
  return `${prefix}***@${domain}`;
};

export const maskIdentifier = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed) return trimmed;
  if (trimmed.length <= 6) return "***";
  return `${trimmed.slice(0, 3)}***${trimmed.slice(-2)}`;
};

export const sanitizeTextForLogs = (value) => {
  if (typeof value !== "string") return value;
  return value
    .replace(EMAIL_PATTERN, (match) => maskEmail(match))
    .replace(UUID_LIKE_PATTERN, (match) => maskIdentifier(match));
};

export const sanitizeLogData = (value) => {
  if (Array.isArray(value)) {
    return value.map((entry) => sanitizeLogData(entry));
  }

  if (!value || typeof value !== "object") {
    if (typeof value === "string") {
      return sanitizeTextForLogs(value);
    }
    return value;
  }

  return Object.entries(value).reduce((acc, [key, entry]) => {
    if (SENSITIVE_KEY_PATTERN.test(key)) {
      if (/email/i.test(key)) {
        acc[key] = typeof entry === "string" ? maskEmail(entry) : "<redacted-email>";
      } else {
        acc[key] = typeof entry === "string" ? maskIdentifier(entry) : "<redacted>";
      }
      return acc;
    }

    acc[key] = sanitizeLogData(entry);
    return acc;
  }, {});
};

export const sanitizeErrorForLogs = (error) => {
  if (!error) return error;
  if (typeof error === "string") return sanitizeTextForLogs(error);

  return sanitizeLogData({
    code: error.code,
    message: error.message,
    details: error.details,
    customData: error.customData,
  });
};

export const sanitizeDescriptionForLogs = (value) => sanitizeTextForLogs(value);
